import { FC } from 'react';

import { usePathname } from '@telialt/utils/src/pathname';

import { useMaintenanceData } from '../hooks/useMaintenanceData';
import { useNavigation } from '../hooks/useNavigationData';
import { Navigation } from './Navigation';

export const NavigationWithQuery: FC = () => {
    const pathname = usePathname();
    const { data: navigationData, isLoading: isNavigationLoading } = useNavigation({ pathname });
    const { data: maintenanceData } = useMaintenanceData();

    return (
        <Navigation
            contextLeftMenu={navigationData?.navContextLeftMenu}
            contextRightMenu={navigationData?.navContextRightMenu}
            mainLeftMenu={navigationData?.navMainLeftMenu}
            mainRightMenu={navigationData?.navMainRightMenu}
            additionalMenu={navigationData?.navAdditionalMenu}
            maintenance={maintenanceData}
            isLoading={isNavigationLoading}
        />
    );
};
